var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsnewWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 25.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-whatsnew-workspace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.22,7.92A17.59,17.59,0,0,0,16.61.54a13,13,0,0,1,8.24,7.38Zm-1.68,0C16.78,3.27,15,0,12.93,0S9.07,3.27,8.31,7.92Zm.21,1.67H8.1a32.49,32.49,0,0,0,0,6.67h4.05a10.57,10.57,0,0,1,5.65-6.15C17.78,9.94,17.77,9.76,17.75,9.59ZM9.24.54A13,13,0,0,0,1,7.92H6.64A17.53,17.53,0,0,1,9.24.54Zm-3,12.39c0-1.12.06-2.24.17-3.34h-6a12.64,12.64,0,0,0,0,6.67h6C6.32,15.17,6.26,14,6.26,12.93Zm5.38,6.46a9.77,9.77,0,0,1,.12-1.46H8.31c.76,4.65,2.54,7.92,4.61,7.92a2.12,2.12,0,0,0,.94-.24A9.9,9.9,0,0,1,11.63,19.39ZM1,17.93a13,13,0,0,0,8.24,7.38,17.59,17.59,0,0,1-2.61-7.38ZM27.83,19.2a.3.3,0,0,0-.11-.23l-4.64-3.82a.3.3,0,0,0-.38,0L18.06,19a.3.3,0,0,0-.11.23v3.54a.59.59,0,0,0,.59.59h2.86a.3.3,0,0,0,.3-.3V20.27A.3.3,0,0,1,22,20h1.78a.3.3,0,0,1,.3.3V23a.3.3,0,0,0,.3.3h2.86a.59.59,0,0,0,.59-.59V19.2Zm2.11-1.09-.63.77a.3.3,0,0,1-.42,0l-5.81-4.78a.3.3,0,0,0-.38,0l-5.81,4.78a.3.3,0,0,1-.42,0l-.63-.77a.3.3,0,0,1,0-.42l6.25-5.15a1.18,1.18,0,0,1,1.51,0l2.21,1.82V12.58a.3.3,0,0,1,.3-.3h1.38a.3.3,0,0,1,.3.3V16l2.06,1.7A.3.3,0,0,1,29.93,18.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsnewWorkspace);
export default __webpack_public_path__ + "static/media/icon-whatsnew-workspace.0181082168e30d08a0d15a7edda7785a.svg";
export { ForwardRef as ReactComponent };